module.exports = __webpack_public_path__ + "img/checkmark_enabled.f17da45c.svg";